import type { Int32ItemsFilter } from '@app/pages/Clients/Records/utils/msToInt32ItemsFilters';
import type {
  NAuth,
  UpdateRecordDataInterface,
  WithActiveBranchId,
} from '@app/types';
import type { NServices } from '@app/types/Services';

export enum RecordsEndpoints {
  GetEmployeesRecords = 'GetEmployeesRecords',
  GetRecordPayments = 'GetRecordPayments',
  GetClientRecords = 'GetClientRecords',
  UpdateRecord = 'UpdateRecord',
  PrepareRecordCreation = 'PrepareRecordCreation',
  CheckRecordTimes = 'CheckRecordTimes',
  ExportRecordsByChainToExcel = 'ExportRecordsByChainToExcel',
  ExportRecordsByOrganizationToExcel = 'ExportRecordsByOrganizationToExcel',
}

export interface GetEmployeesRecordsRequest {
  UserId: number;
  Database: string;
  ActiveBranchId: number;
  date: string;
}

export interface GetRecordPaymentsRequest {
  ActiveBranchId: number;
  recordIds: number[];
}

export interface GetClientRecordsRequest {
  UserId: number;
  Database: string;
  ActiveBranchId: number;
  clientId: number;
}

export interface UpdateRecordRequest {
  ActiveBranchId: NAuth.UserPrint['activeBranchId'];
  data: UpdateRecordDataInterface;
}

export interface PrepareRecordCreationRequest
  extends NServices.PrepareRecordCreationHandlerProps {
  UserId: number;
  Database: string;
  ActiveBranchId: number;
}

export interface CheckRecordTimesRequest
  extends NServices.CheckRecordTimesProps {
  UserId: number;
  Database: string;
  ActiveBranchId: number;
}

export interface Warnings {
  Message: string;
  Type: 'outside-schedule' | 'intersection';
}
export interface CheckRecordTimesResponse {
  BranchId: number;
  EmployeeId: number;
  TimeE: string;
  TimeS: string;
  Warnings: Warnings[];
}

export interface ModelExportRecordsByChain {
  DateCreateS?: string | null;
  DateCreateE?: string | null;
  DateVisitS?: string | null;
  DateVisitE?: string | null;
  RecordTagsFilters?: Int32ItemsFilter[] | null;
  ClientTagsFilters?: Int32ItemsFilter[] | null;
  Statuses?: string[] | null;
}

export type ExportRecordsByChainToExcelRequest = WithActiveBranchId<{
  data: ModelExportRecordsByChain;
}>;
export type ExportRecordsByOrganizationToExcelRequest = WithActiveBranchId<{
  data: ModelExportRecordsByChain;
}>;

export interface ExportRecordsToExcelWithoutGroupingRequest
  extends WithActiveBranchId {
  searchId: number;
}
export interface ExportRecordsToExcelRequest
  extends ExportRecordsToExcelWithoutGroupingRequest {}
